import { apiClient } from './config';
import { getClientType } from '../../services/clientConfig';

/**
 * Get client_type from localStorage or URL params
 */
const getClientTypeParam = () => {
  return localStorage.getItem('client_type') || getClientType() || 'default';
};

/**
 * Fetch all signals for the current client
 */
export const fetchSignals = async () => {
  const clientType = getClientTypeParam();
  const response = await apiClient.get('/signal/all', {
    params: { client_type: clientType }
  });
  return response.data;
};

/**
 * Create new traffic signal for the current client
 */
export const createSignal = async (formData) => {
  const clientType = getClientTypeParam();
  // Append client_type to formData
  formData.append('client_type', clientType);
  const response = await apiClient.post('/signal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Update existing traffic signal
 */
export const updateSignal = async (formData, id) => {
  const clientType = getClientTypeParam();
  // Append client_type to formData
  formData.append('client_type', clientType);
  const response = await apiClient.put(`/signal/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Delete traffic signal
 */
export const deleteSignal = async (id) => {
  const clientType = getClientTypeParam();
  const response = await apiClient.delete(`/signal/${id}`, {
    params: { client_type: clientType }
  });
  return response.data;
};

// Re-export config
export { apiClient, API_BASE_URL, getAuthHeaders } from './config';
